import { Stack } from '@sureco/design-system'
import { Typography, Button } from 'antd'
import React from 'react'
const { Text, Title } = Typography

export default function HandbookSection({
  title = 'Employee Benefit Handbook',
  emptyMessage = 'Upload a PDF to show on the employee dashboard.',
  handbooks,
  onChooseFile,
  onDelete,
  isUploading,
  uploadState,
  fileInputRef,
  onFileChange,
}) {
  const buttonLabel =
    uploadState === 'presigning'
      ? 'Getting URL…'
      : uploadState === 'uploading'
        ? 'Uploading…'
        : uploadState === 'saving'
          ? 'Saving…'
          : 'Upload PDF'

  const hasHandbooks = handbooks.length > 0

  return (
    <div style={{ flex: 1 }}>
      <Stack space={12}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Title level={5}>{title}</Title>

          <Button type="primary" onClick={onChooseFile} loading={isUploading}>
            {buttonLabel}
          </Button>
        </div>

        {!hasHandbooks && <Text type="secondary">{emptyMessage}</Text>}

        <input
          ref={fileInputRef}
          type="file"
          accept="application/pdf"
          style={{ display: 'none' }}
          onChange={onFileChange}
        />

        {hasHandbooks && (
          <div style={{ marginTop: 12 }}>
            {handbooks.map((hb) => (
              <div
                key={`${hb.year}-${hb.language}-${hb.s3Key}`}
                style={{
                  marginTop: 8,
                  padding: '12px 16px',
                  borderRadius: 8,
                  background: '#F9FBFC',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span
                    style={{
                      width: 24,
                      height: 24,
                      background: '#E6F7F9',
                      borderRadius: 4,
                      marginRight: 8,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    📄
                  </span>

                  <a style={{ marginRight: 8 }} href="#">
                    {hb.fileName}
                  </a>

                  <Text type="secondary">
                    ({hb.language === 'english' ? 'English' : 'Spanish'})
                  </Text>
                </div>

                <Button type="link" danger onClick={() => onDelete(hb)}>
                  DELETE
                </Button>
              </div>
            ))}
          </div>
        )}
      </Stack>
    </div>
  )
}
